import { combineReducers } from 'redux';
import { createActions, createReducer } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions(
  {
    login: ['email', 'password', 'firebaseIdToken', 'resolve'],
    logout: [],
    // Fired when a login replaces an existing session (e.g. business -> customer).
    // Reset-style sagas registered with takeLogout also run on this.
    switchSession: [],
        // Admin-only: switch into a business session (businessId null = back to admin).
    impersonate: ['businessId', 'resolve'],
    fetchImpersonationOptions: ['query', 'resolve'],
    
    loginRequest: ['credentails'],
    loginSuccess: ['tokens'],
    loginFailure: ['error'],
  },
  { prefix: 'cb/auth/login/' },
);

const fetching = createReducer(false, {
  [types.LOGIN_REQUEST]: () => true,
  [types.LOGIN_SUCCESS]: () => false,
  [types.LOGIN_FAILURE]: () => false,
});

const credentails = createReducer(null, {
  [types.LOGIN_REQUEST]: (_, { credentails }) => credentails,
});

const error = createReducer(null, {
  [types.LOGIN_REQUEST]: () => null,
  [types.LOGIN_SUCCESS]: () => null,
  [types.LOGIN_FAILURE]: (_, { error }) => error,
});

export default combineReducers({
  fetching,
  credentails,
  error,
});